var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('router-link',{staticClass:"a-breadcrumbs__list__item d-inline-flex align-center subtitle-2 px-2",class:{
      'a-breadcrumbs__list__item--disabled': _vm.index === _vm.length - 1
    },attrs:{"to":_vm.item.url}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]),(_vm.index !== _vm.length - 1)?_c('v-icon',{staticClass:"gray--text text--darken-3 ml-1"},[_vm._v(" mdi-slash-forward ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }